'use client';

import * as React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/ca'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/de'
import 'dayjs/locale/pt'
import 'dayjs/locale/ar'

const dayjsLocaleMap: Record<string, string> = {
  en: 'en',
  es: 'es',
  ca: 'ca',
  fr: 'fr',
  it: 'it',
  de: 'de',
  pt: 'pt',
  ar: 'ar'
}

export default function DatePickersProvider({
  children,
  locale = 'en',
}: {
  children: React.ReactNode;
  locale?: string;
}) {
  const adapterLocale = dayjsLocaleMap[locale] ?? 'en'
  
  React.useEffect(() => {
    dayjs.locale(adapterLocale)
  }, [adapterLocale])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      {children}
    </LocalizationProvider>
  )
}